<template lang="pug">
  BaseMarkdown.PostContentMarkdown.post-content-markdown(
    :text="data.content",
    v-improve-links,
  )
</template>

<script>
import { BasePostClass } from 'Classes';
import BaseMarkdown from 'Components/Base/BaseMarkdown';

export default {
  name: 'PostContentMarkdown',
  components: {
    BaseMarkdown,
  },
  props: {
    data: {
      type: BasePostClass,
      required: true,
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
@import  '~Styles/components/_typography.sass'

.post-content-markdown
  ::v-deep *
    &:first-child
      margin-top: 0
  ::v-deep blockquote
    border-left: solid 5px $secondary
    padding-left: 20px
    font-size: 24px
    line-height: 36px
    margin-top: 35px
    margin-bottom: 35px
    color: $primary
    p
      font-size: 24px
      line-height: 36px
      margin-bottom: 0
      +font(300)
  ::v-deep p
    &:last-child
      margin-bottom: 0
  ::v-deep .base-image
    margin-top: 35px
    margin-bottom: 35px
    max-width: 100%
    width: 100%
  ::v-deep h1
    margin-bottom: 25px
    margin-top: 50px
    color: $primary
    @media screen and (max-width: 767px)
      margin-top: 35px
      margin-bottom: 20px
  ::v-deep h2
    margin-bottom: 25px
    margin-top: 50px
    @media screen and (max-width: 767px)
      margin-top: 35px
      margin-bottom: 20px
  ::v-deep h3
    margin-bottom: 20px
    margin-top: 50px
    @media screen and (max-width: 767px)
      margin-top: 35px
      margin-bottom: 10px
  ::v-deep ul,
  ::v-deep ol
    margin-left: 30px
    margin-bottom: 15px
    &:last-child
      margin-bottom: 0
  ::v-deep a:not(.author-row__image)
    @extend .link-2
  ::v-deep .note
    margin-top: 35px
    margin-bottom: 35px
    font-size: 12px
    line-height: 17px
    color: $text_gray
    +font(500)
    a
      font-size: 12px
      line-height: 17px
  ::v-deep iframe
    &:not(.podcast)
      width: 100%
      height: 402px
      @media screen and (max-width: 567px)
        height: 217px
  ::v-deep .additional-link-container
    display: flex !important
    flex-direction: row
    background-color: $alabaster
    border: solid 1px $de_york_opasity
    border-bottom: solid 1px $de_york_opasity !important
    border-radius: 2px
    position: relative
    margin-top: 55px
    margin-bottom: 75px
    +mt(.3s)
    @media screen and (max-width: 576px)
      margin-top: 40px
      margin-bottom: 60px
    &:before
      +mt(.3s)
      content: ''
      position: absolute
      background: $gray-30
      width: 100px
      height: 146px
      z-index: -1
      top: 50%
      right: 30px
      transform: translate(0%, -50%) rotate(0deg)
      @media screen and (max-width: 576px)
        transform: translate(0%, -50%) rotate(-8deg)
      @media screen and (max-width: 340px)
        right: 25px
    &:hover
      +mt(.3s)
      &:before
        +mt(.3s)
        transform: translate(0%, -50%) rotate(-8deg)
      .download-title
        span
          +mt(.3s)
          border-bottom: solid 1px transparent !important
    .text-wrap
      padding: 20px
      width: 85%
      pointer-events: none
      display: flex
      align-items: flex-start
      flex-direction: column
      @media screen and (max-width: 767px)
        width: 75%
      @media screen and (max-width: 576px)
        justify-content: center
        width: 67%
      @media screen and (max-width: 340px)
        padding: 15px
      .download-title
        font-size: 14px
        line-height: 19.6px
        +font(500)
        color: $secondary
        display: flex
        flex-direction: row
        justify-content: flex-start
        align-items: center
        span
          line-height: 14px
          border-bottom: solid 1px $secondary
          +mt(.3s)
        i
          position: relative
          width: 16px
          height: 16px
          margin-left: 4px
          &:after
            content: ''
            width: 16px
            height: 16px
            background-image: url('~images/icons/fa-down-to-line.svg')
            background-repeat: no-repeat
            top: 0px
            left: 0
            position: absolute
      .link-title
        border-bottom: none
        color: $secondary
        font-size: 16px
        line-height: 22.4px
        +font(500)
        margin-top: 12px
        @media screen and (max-width: 576px)
          width: 100%
          max-width: 185px
    .img-wrap
      width: 100px
      height: 146px
      background-size: cover
      background-repeat: no-repeat
      position: absolute
      top: 50%
      right: 30px
      transform: translate(0%, -50%)
      pointer-events: none
      +mt(.3s)
      @media screen and (max-width: 340px)
        right: 25px
    &.selling-farmland
      .img-wrap
        background-image: url('~images/general/selling-farmland-learning.png')
    &.whitepaper
      .img-wrap
        background-image: url('~images/general/whitepaper-thumbnail.png')
  ::v-deep hr
    margin-top: 30px
    margin-bottom: 30px
</style>
